<template>
    <div class="order">
        <Header ref="header" :title="title" :titleRight="titleRight" @backPage="onBack"></Header>
        <div class="address">
            <div class="item">
                <div class="item-left">
                    配送方式
                </div>
                <div class="item-right arrow" @click="onSend">
                    <input type="text" value="" v-model="despatch" readonly>
                </div>
            </div>
        </div>
        <div class="products mtop20" v-if="type == 1">
            <div class="item borderBot" @click="onAddress">
                <div class="item-left arrow" v-if="Object.keys(addressUser).length">
                    <div class="name">{{ addressUser.name }}<span>{{ addressUser.phone }}</span></div>
                    <div class="content" v-text="addressUser.province + addressUser.city + addressUser.area + addressUser.address"></div>
                </div>
                <div class="item-left arrow" v-else>
                    <div class="name2">请选择地址</div>
                </div>
            </div>
            <div class="commodity">
                <div v-for="item in productData" :key="item.id">
                    <div class="item2" v-for="it in item" :key="it.id">
                        <div class="item-left">
                            <img class="borderRedius12" v-lazy="it.pictureUrl + '?x-oss-process=image/resize,m_pad,h_400,w_400/quality,Q_100'" alt="">
                        </div>
                        <div class="item-right">
                            <div class="name">{{ it.skuShowName }}</div>
                            <div class="money" v-if="presaleId">¥ ???? <span><sub>X</sub>{{ it.quantity }}</span></div>
                            <div class="money" v-else>¥ {{ it.price | NumFormat }} <span><sub>X</sub>{{ it.quantity }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="products" v-if="type == 2">
            <div v-for="(item, index) in productData" :key="index">
                <div class="item mtop20" @click="onAddress(index)" v-show="JSON.stringify(addressInfo[index]) !== '{}'">
                    <div class="item-left arrow">
                        <div class="name">{{ addressInfo[index].name }}<span>{{ addressInfo[index].phone }}</span></div>
                        <div class="content" v-text="addressInfo[index].province + addressInfo[index].city + addressInfo[index].area + addressInfo[index].address"></div>
                    </div>
                </div>
                <div class="item mtop20" @click="onAddress(index)" v-show="JSON.stringify(addressInfo[index]) == '{}'">
                    <div class="item-left arrow">
                        <div class="name2">请选择地址</div>
                    </div>
                </div>
                <div class="commodity mtop20">
                    <div class="item2" v-for="it in item" :key="it.id">
                        <div class="item-left">
                            <img class="borderRedius12" v-lazy="it.pictureUrl + '?x-oss-process=image/resize,m_pad,h_400,w_400/quality,Q_100'" alt="">
                        </div>
                        <div class="item-right">
                            <div class="name">{{ it.skuShowName }}</div>
                            <div class="money" v-if="presaleId">¥ ???? <span><sub>X</sub>{{ it.quantity }}</span></div>
                            <div class="money" v-else>¥ {{ it.price | NumFormat }} <span><sub>X</sub>{{ it.quantity }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mtop20" v-if="presaleIdShow">
            <Step :stepInfo='stepInfo' :downShow='true' @onChecked='onChecked' />
        </div>
        <div class="address mtop20">
            <div class="item">
                <div class="item-left">
                    订单备注
                </div>
            </div>
            <div class="item ptop0">
                <textarea rows="5" maxlength="100" placeholder="请输入期望发货时间" v-model="remark"></textarea>
                <span class="fontSize">100个字</span>
            </div>
        </div>
        <div class="photo mtop20">
            <h3 class="f32">上传报备信息<span class="f28 col999">(最多8张)</span></h3>
            <div class="pic">
                <div class="picLi" v-for="(item, index) in pricList" :key="index">
                    <img :src="item.annexUrl" preview="9" preview-text="" alt="">
                    <div @click="onClose(index)" class="close"></div>
                </div>
                <div class="picLi" @click="onPic('orderPic')" v-if="pricList.length < 8">
                    <img src="../../../assets/img/b2b/image_add@2x.png" alt="">
                </div>
            </div>
        </div>
        <div class="footer" v-show="showStatic">
            <div class="activity borderBot borderBotLeft0 borderTop">
                <div class="item col333">
                    <div class="itemLeft">总价</div>
                    <div class="itemRight">￥{{ parseFloat(totalPrice) | NumFormat }}</div>
                </div>
            </div>
            <div class="foot">
                <div class="item">
                    <div class="item-left">共{{ totalNum }}件 合计：
                        <span class="colFF7A45">¥ {{ parseFloat(totalPrice) | NumFormat }}</span>
                    </div>
                    <div class="item-right">
                        <div class="btn" @click="submitOrder">提交订单</div>
                    </div>
                </div>
            </div>
        </div>
        <mt-popup v-model="popupVisible2" position="bottom" class="mint-popup mint-zj" lockScroll="true">
            <div class="ps">
                <div class="item borderBot col8E8E93">配送方式</div>
                <div class="item borderBot" @click="onDispatch(1)">送货上门</div>
                <div class="item" v-show="typeShow" @click="onDispatch(2)">自提</div>
            </div>
            <div class="ps m20">
                <div class="item colFF7A45" @click="onCancel">取消</div>
            </div>
        </mt-popup>
        <StopPopup ref="popStop"></StopPopup>
        <PopupApprove ref="popApp"></PopupApprove>
    </div>
</template>
<script>
import Header from '../../common/header'
import PopupApprove from '../common/approvePopup'
import StopPopup from '../common/stopPopup'
import Step from '../common/step'
import { Toast } from 'vant'
import { mapActions, mapMutations, mapState } from 'vuex'
import { clearCache, newCache } from '@/utils/index'
import { versions } from '../../common/version'
export default {
    name: 'activityOrder',
    components: {
        Header,
        PopupApprove,
        Step,
        StopPopup
    },
    data () {
        return {
            title: '确认订单',
            titleRight: '',
            despatch: '送货上门',
            popupVisible2: false,
            popupVisible3: false,
            stepInfo: [
                { title: '支付定金', content: '待付定金 ¥0.00', downColor: true, contentColor: true },
                { title: '支付尾款', content: '02月22日 00:00:01 开始开始支付尾款', downColor: false, contentColor: false }
            ],
            presaleIdShow: false,
            type: 1, // 提货方式
            payMethod: 4, // 支付方式
            confirmOrderBack: '', // 确认订单页面返回
            addressUser: {},
            goodsId: '',
            presaleId: '',
            productData: [],
            orderDiscountList: [], // 优惠与活动
            disb: true,
            remark: localStorage.getItem('remark') || '',
            showStatic: true,
            documentHeight: document.documentElement.clientHeight,
            priceRules: '',
            pricList: [],
            rebatePrice: 0,
            addressInfo: [],
            orderProductGroups: '',
            orderType: 0,
            isApproveValue: 3,
            checked: true,
            userInfo: '',
            activityParams: '',
            infoArr: [],
            reserveAmount: 0,
            typeShow: true,
            isEnabled: true,
            productShow: false, // 商品数据加载完毕才可以进行数据提交
            groupValue: ''
        }
    },
    beforeRouteEnter (to, from, next) {
        newCache('activityOrder')
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (to.name === 'selectAddress' || to.name === 'selectDeliveryAddress' || to.name === 'presellServer') {
            newCache('activityOrder')
        } else if (from.name !== 'selectAddress' || from.name === 'selectDeliveryAddress') {
            this.setAddressList({})
            this.setAddressInfo([])
            this.setPicList([])
            clearCache('activityOrder')
        }
        next()
    },
    activated () {
        if (Object.keys(this.addressListInfo).length && this.type === 1) {
            this.addressUser = this.addressListInfo
            this.$forceUpdate()
        } else if (!Object.keys(this.addressListInfo).length && this.type === 1) {
            this.addressUser = {}
            this.getAddress()
            this.$forceUpdate()
        }
        if (Object.keys(this.addressListInfos).length && this.type === 2) {
            this.addressInfo = this.addressListInfos
            this.$forceUpdate()
        }
        if (this.getPicList.length) {
            this.pricList = this.getPicList
            this.$forceUpdate()
        }
    },
    computed: {
        ...mapState({
            addressListInfo: state => state.b2b.addressList,
            addressListInfos: state => state.b2b.addressInfo,
            getPicList: state => state.b2b.picList
        }),
        totalPrice () {
            let price = 0
            let totalPriceMont = 0
            this.productData.forEach((item) => {
                item.forEach(it => {
                    price += parseFloat(it.price) * parseInt(it.quantity)
                })
            })
            if (this.presaleId) {
                totalPriceMont = this.reserveAmount
            } else {
                totalPriceMont = price > 0 ? price : 0
            }
            return totalPriceMont
        },
        totalNum () {
            let num = 0
            this.productData.forEach((item) => {
                item.forEach(it => {
                    num += parseInt(it.quantity)
                })
            })
            return num
        }
    },
    methods: {
        ...mapMutations({
            setAddressList: 'GET_ADDRESS_INFO',
            setAddressInfo: 'GET_ADDRESSLIST_INFO',
            setPicList: 'GET_PICLIST_INFO'
        }),
        ...mapActions([
            'setActivity',
            'getStatusData',
            'getIsActivity',
            'getDepotAddress',
            'getDefaultAddress',
            'getSubmitOrder',
            'getAddressListData',
            'getProductData',
            'isApprove'
        ]),
        onBack () {
            localStorage.removeItem('remark')
            this.$router.push({ path: this.confirmOrderBack, query: { id: this.goodsId } })
        },
        onSend () {
            this.popupVisible2 = true
        },
        onChecked (val) {
            this.checked = val
        },
        onPic (target) {
            if (this.pricList.length >= 8) {
                return false
            }
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'callPhoto',
                    'target': target
                })
            } else {
                window.kfxt.callPhoto(target)
            }
        },
        getOEImgUrl (tag, url) {
            this.pricList.push({ 'annexType': 1, 'annexUrl': url })
            this.$previewRefresh()
            localStorage.setItem('pricList', JSON.stringify(this.pricList))
        },
        onClose (index) {
            this.pricList.splice(index, 1)
            localStorage.setItem('pricList', JSON.stringify(this.pricList))
        },
        onAddress (index) {
            localStorage.setItem('selectAddressBack', this.$router.history.current.fullPath)
            localStorage.setItem('type', this.type)
            if (parseInt(this.type) === 2) {
                const merchantCode = this.productData[index][0]['sourceMerchantCode']
                // localStorage.setItem('addressInfo', JSON.stringify(this.addressInfo))
                this.$router.push({ path: '/b2b/address/selectDeliveryAddress', query: { index: index, merCode: merchantCode, activityShow: 1 } })
            } else {
                this.setAddressList(this.addressUser)
                this.$router.push({ path: '/b2b/address/selectAddress', query: { type: 1, activityShow: 1 } })
            }
        },
        onDispatch (num) {
            this.type = num
            this.despatch = parseInt(num) === 1 ? '送货上门' : '自提'
            this.popupVisible2 = false
            if (num == 2) {
                localStorage.setItem('type', num)
                let arr = []
                this.orderProductGroups.forEach(item => {
                    arr.push({})
                })
                this.addressInfo = localStorage.getItem('addressInfo') ? JSON.parse(localStorage.getItem('addressInfo')) : arr
            } else {
                localStorage.setItem('type', num)
                this.getAddress()
            }
        },
        onCancel () {
            this.popupVisible2 = false
        },
        async getApprove () {
            await this.isApprove({
                companyCode: this.userInfo.companyCode
            }).then((data) => {
                this.isApproveValue = data.authenticationStatus
                this.isEnabled = data.isEnabled
            })
        },
        async getStatus (productId) {
            if (!this.isEnabled) {
                this.$refs.popStop.onShow()
                this.disb = true
                return false
            }
            try {
                await this.getStatusData({
                    skuIds: productId,
                    merchantCode: this.userInfo.belongMerchantCode,
                    memberCode: this.userInfo.companyCode
                })
                if (!(this.groupValue || this.presaleId)) {
                    const data2 = await this.getIsActivity({
                        spikeId: this.activityParams.activityId
                    })
                    if (!data2) {
                        Toast({
                            message: '该商品活动已结束，请重新购买',
                            duration: 2000
                        })
                        setTimeout(() => {
                            this.$router.push({ path: this.confirmOrderBack })
                        }, 2000)
                        return false
                    }
                }
                this.addressUser.contactName = this.addressUser.contactName || ''
                this.addressUser.contactMobile = this.addressUser.contactMobile || ''
                let orderShipping = []
                if (this.type == 1) {
                    if (!this.addressUser.province) {
                        Toast({
                            message: '请选择收货地址!',
                            duration: 1000
                        })
                        this.disb = true
                        return false
                    }
                    orderShipping = [{
                        address: this.addressUser.province +
                            this.addressUser.city + this.addressUser.area + this.addressUser.address + '&' + this.addressUser.contactName + '&' + this.addressUser.contactMobile,
                        mobile: this.addressUser.phone,
                        name: this.addressUser.name,
                        merchantCode: this.userInfo.belongMerchantCode,
                        province: this.addressUser.province,
                        city: this.addressUser.city,
                        area: this.addressUser.area
                    }]
                } else {
                    let arr = []
                    this.addressInfo.forEach((item, index) => {
                        if (item.name) {
                            arr.push({
                                address: item.province + item.city + item.area + item.address + '&' + item.contactName + '&' + item.contactMobile,
                                mobile: item.phone,
                                name: item.name,
                                merchantCode: this.productData[index][0]['sourceMerchantCode'],
                                province: item.province,
                                city: item.city,
                                area: item.area
                            })
                        }
                    })
                    orderShipping = arr
                    if (this.productData.length !== arr.length) {
                        Toast({
                            message: '请选择相对应的地址!',
                            duration: 1000
                        })
                        this.disb = true
                        return false
                    }
                }
                let productData = this.productData
                let productArr = []
                productData.forEach(item => {
                    item.forEach(it => {
                        productArr.push(it)
                    })
                })
                if (!this.checked) {
                    Toast({
                        message: '请阅读并勾选同意协议，否则无法提交订单!',
                        duration: 2000
                    })
                    this.disb = true
                    return false
                }
                try {
                    Toast.loading({
                        message: '提交中...',
                        duration: 0,
                        forbidClick: true
                    })
                    await this.getSubmitOrder({
                        createBy: this.userInfo.id,
                        memberCode: this.userInfo.companyCode,
                        merchantCode: this.userInfo.belongMerchantCode,
                        memberName: this.userInfo.companyName,
                        merchantName: this.userInfo.belongMerchantName,
                        customerName: this.userInfo.companyName + ' ' + this.userInfo.username,
                        orderAnnexes: this.pricList, // 订单附件
                        remark: this.remark, // 备注
                        payMethod: this.payMethod, // 支付方式
                        shippingMethod: this.type, // 送货方式 1，送货上门 2，自提
                        orderShippings: orderShipping, // 地址
                        orderProducts: productArr,
                        orderType: this.orderType,
                        presaleId: this.presaleId,
                        spikeId: this.activityParams && this.activityParams.activityId,
                        groupId: this.groupValue || '',
                        groupParticipationId: this.$route.query.groupParticipationId || ''
                    }).then((data) => {
                        Toast.clear()
                        this.removeItem()
                        if (!(this.groupValue || this.presaleId)) {
                            this.activityInfo()
                        }
                        this.$store.commit('SAVE_ONCE_PAYMENT_PRICE', 0)
                        if (this.isApproveValue !== 3) {
                            this.$refs.popApp.onShow()
                            return false
                        }
                        this.$router.replace({ path: '/b2b/payment/cashier', query: { orderId: data.id, presaleId: this.presaleId } })
                    })
                } catch (error) {
                    this.disb = true
                }
            } catch (error) {
                this.disb = true
            }
        },
        removeItem () {
            localStorage.removeItem('orderNum')
            localStorage.removeItem('effectData')
            localStorage.removeItem('addressInfo')
            localStorage.removeItem('effectData')
            localStorage.removeItem('pricList')
            localStorage.removeItem('spikeData')
            localStorage.removeItem('goodsId')
            localStorage.removeItem('presaleId')
            localStorage.removeItem('groupId')
            localStorage.removeItem('goodsData')
            localStorage.removeItem('type')
            localStorage.removeItem('addressId')
            localStorage.removeItem('addressList')
            localStorage.setItem('paymentBack', '/b2b/order/orderList')
        },
        async submitOrder () {
            if (!this.disb || !this.productShow) {
                return false
            }
            this.disb = false
            if (!this.productData.length) {
                Toast('很抱歉，您购买的商品不存在')
                this.disb = true
                return false
            }
            if (this.remark) {
                if (this.remark.length > 100) {
                    Toast('订单备注不可超过100个字')
                    this.disb = true
                    return false
                }
            }
            let productId = []
            this.productData.forEach(item => {
                item.forEach(it => {
                    productId.push(it.skuId)
                })
            })
            this.getStatus(productId.join(','))
        },
        async getAddress () {
            await this.getDefaultAddress({
                memberCode: this.userInfo.companyCode
            }).then((data) => {
                if (data) {
                    this.addressUser = data
                    this.setAddressList(data)
                }
            })
        },
        async getAddressList () {
            await this.getAddressListData({
                memberCode: this.userInfo.companyCode
            }).then((data) => {
                if (data.length) {
                    this.$router.push({ path: '/b2b/address/selectAddress' })
                } else {
                    this.$router.push({ path: '/b2b/address/addAddress' })
                }
            })
        },
        async getProduct (addressList, addressInfo) {
            this.infoArr = []
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            await this.getProductData({
                merchantCode: this.userInfo.belongMerchantCode,
                memberCode: this.userInfo.companyCode,
                orderProductList: this.priceRules,
                shippingMethod: this.type,
                groupId: this.groupValue,
                presaleId: this.presaleId,
                spikeId: this.activityParams && this.activityParams.activityId // 拼团商品信息不传spikeId
            }).then((data) => {
                this.orderProductGroups = data.orderProductGroups
                this.orderType = data.orderType // 0: 普通订单 1：组合订单
                // 对返回数据进行处理，添加productId
                let arr = [] // 存放商品的列表
                data.orderProductGroups.forEach(async (item, index) => {
                    item.orderProducts.map(item => {
                        item.productId = item.skuId
                    })
                    arr.push(item.orderProducts)
                })
                this.productData = arr
                // 结束
                // 为折叠效果做的处理
                let productArr2 = []
                arr.forEach((item, index) => {
                    productArr2.push(...arr[index])
                })
                this.productData2 = productArr2
                // 结束
                // 为多个地址的属性初始化
                let prductArr = JSON.parse(JSON.stringify(this.orderProductGroups))
                let prdObject = prductArr.fill({})
                this.productShow = true
                this.setAddressInfo(prdObject)
                this.getAddress()
                if (this.presaleId) {
                    this.reserveAmount = data.reserveAmount
                    let d = new Date(data.retainageStartTime)
                    this.stepInfo[0]['content'] = '待付定金 ¥' + data.reserveAmount
                    this.stepInfo[1]['content'] = (d.getMonth() + 1) + '月' + d.getDate() + '日 ' + this.num(d.getHours()) + ':' + this.num(d.getMinutes()) + ':' + this.num(d.getSeconds()) + '开始支付尾款'
                    this.presaleIdShow = true
                }
                Toast.clear()
            })
        },
        num (n) {
            return n < 10 ? '0' + n : '' + n
        },
        async getAddressInfo (merchantCode) {
            await this.getDepotAddress({
                merchantCode: merchantCode
            }).then((data) => {
                if (!data) {
                    return false
                }
                this.infoArr.push(data.length)
            })
        },
        activityInfo () {
            this.activityParams.categoryName = 1
            this.setActivity(this.activityParams)
            localStorage.setItem('spikeData', JSON.stringify(this.activityParams))
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo')) // 获取用户的基本信息
        this.activityParams = JSON.parse(localStorage.getItem('spikeData'))
        this.goodsId = localStorage.getItem('goodsId') // 商品的id
        this.presaleId = localStorage.getItem('presaleId') // 预售id
        this.priceRules = JSON.parse(localStorage.getItem('goodsData')) // 商品数组信息
        this.type = parseInt(localStorage.getItem('type')) // 选择送货方式
        this.confirmOrderBack = localStorage.getItem('confirmOrderBack')
        let addressList = localStorage.getItem('addressList') ? JSON.parse(localStorage.getItem('addressList')) : ''
        let addressInfo = localStorage.getItem('addressInfo') ? JSON.parse(localStorage.getItem('addressInfo')) : ''
        this.pricList = localStorage.getItem('pricList') ? JSON.parse(localStorage.getItem('pricList')) : []
        this.despatch = parseInt(this.type) === 1 ? '送货上门' : '自提'
        this.groupValue = this.$route.query.groupId || localStorage.getItem('groupId')
        this.getProduct(addressList, addressInfo)
        this.getApprove()
        window.getOEImgUrl = (tag, url) => {
            this.getOEImgUrl(tag, url)
        }
        if (this.$route.query.groupId) {
            localStorage.setItem('groupId', this.$route.query.groupId)
        } else {
            localStorage.removeItem('groupId')
        }
        window.onresize = () => {
            if (/Android/gi.test(navigator.userAgent)) {
                if (this.documentHeight > document.documentElement.clientHeight) {
                    this.showStatic = false
                } else {
                    this.showStatic = true
                }
                window.addEventListener('resize', function () {
                    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
                        window.setTimeout(function () {
                            document.activeElement.scrollIntoViewIfNeeded()
                        }, 10)
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
input {
    font-size: 32px;
    text-align: right;
}
.mbot {
    margin-bottom: 188px;
}
.showHeight {
    height: 400px;
}
.showStatic {
    position: static;
}
.order {
    font-size: 32px;
    background: #f5f5f5;
    padding-bottom: 370px;
    overflow: hidden;
    .address {
        background: #ffffff;
        .item {
            padding: 32px;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            position: relative;
            line-height: 44px;
            .item-left {
                position: relative;
                .name {
                    margin-bottom: 22px;
                    span {
                        margin-left: 20px;
                    }
                }
                .content {
                    color: #666666;
                    line-height: 44px;
                    white-space: normal;
                    word-break: break-all;
                }
            }
            .item-right {
                position: relative;
                padding-right: 40px;
                width: 360px;
                text-align: right;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
                &.fanl {
                    font-size: 30px;
                    color: #ff7a45;
                    padding-right: 0;
                    span {
                        padding-left: 20px;
                    }
                }
                input {
                    line-height: 44px;
                    padding: 0;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
            }
            textarea {
                font-size: 32px;
            }
            .fontSize {
                position: absolute;
                right: 32px;
                bottom: 32px;
                color: #c3c3c3;
                font-size: 26px;
            }
        }
    }
    .products {
        .item {
            padding: 32px;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            position: relative;
            line-height: 44px;
            background: #ffffff;
            .item-left {
                width: 100%;
                position: relative;
                padding-right: 40px;
                .name {
                    margin-bottom: 22px;
                    span {
                        margin-left: 20px;
                    }
                }
                .name2 {
                    margin-bottom: 0;
                    height: 100px;
                    line-height: 100px;
                }
                .content {
                    color: #666666;
                    line-height: 44px;
                    white-space: normal;
                    word-break: break-all;
                }
                &.arrow:after {
                    top: 30px;
                }
            }
            .item-right {
                position: relative;
                padding-right: 40px;
                width: 360px;
                text-align: right;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
                input {
                    line-height: 44px;
                    padding: 0;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
            }
            textarea {
                font-size: 32px;
            }
            .fontSize {
                position: absolute;
                right: 32px;
                bottom: 32px;
                color: #c3c3c3;
                font-size: 26px;
            }
        }
        .commodity {
            padding: 32px 40px;
            background: #ffffff;
            .item2 {
                display: flex;
                justify-content: space-between;
                .item-left {
                    width: 184px;
                    height: 184px;
                    position: relative;
                    img {
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                        margin: 0 auto;
                        background: #f2f3f5;
                        object-fit: cover;
                    }
                }
                .item-right {
                    display: flex;
                    flex-wrap: wrap;
                    align-content: space-between;
                    flex: 1;
                    font-size: 28px;
                    margin-left: 24px;
                    .name {
                        flex: 0 0 100%;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }
                    .money {
                        flex: 0 0 100%;
                        color: #ff7a45;
                        font-size: 30px;
                        span {
                            color: #333333;
                            float: right;
                            sub {
                                font-size: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
    .photo {
        background: #ffffff;
        padding: 32px;
        h3 {
            span {
                padding-left: 12px;
            }
        }
        .pic {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .picLi {
                width: 128px;
                height: 128px;
                margin-top: 32px;
                margin-right: 32px;
                position: relative;
                .close {
                    background-image: url("../../../assets/img/b2b/icon-delete.png");
                    background-repeat: no-repeat;
                    background-size: cover;
                    position: absolute;
                    width: 40px;
                    height: 40px;
                    top: -15px;
                    right: -15px;
                }
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .footer {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .activity {
        padding: 32px;
        background: #ffffff;
        font-size: 28px;
        position: relative;
        .item {
            display: flex;
            justify-content: space-between;
            padding-bottom: 24px;
            &:last-child {
                padding-bottom: 0;
            }
        }
    }
    .foot {
        background: #ffffff;
        font-size: 30px;
        position: relative;
        overflow: hidden;
        .item {
            display: flex;
            justify-content: space-between;
            align-content: center;
            padding: 32px;
            line-height: 64px;
            .item-right {
                font-size: 30px;
                .btn {
                    color: #ffffff;
                    background: #ff7a45;
                    width: 208px;
                    height: 64px;
                    line-height: 64px;
                    text-align: center;
                    border-radius: 64px;
                    &.active2 {
                        color: #ffffff;
                        background: #cccccc;
                        border: 2px solid #cccccc;
                    }
                }
            }
        }
    }
    .mint-zj {
        width: 95% !important;
        border-radius: 8px !important;
        background: none;
        .ps {
            border-radius: 8px;
            background: #ffffff;
            .item {
                padding: 32px;
                font-size: 32px;
                text-align: center;
                position: relative;
                &.borderBot:before {
                    width: auto;
                    left: 0;
                }
            }
        }
    }
}
.dig {
    background: #ffffff;
    width: 590px;
    margin: 0 auto;
    border-radius: 12px;
    .body {
        text-align: center;
        color: #333333;
        padding: 0 56px;
        .img {
            width: 320px;
            height: 228px;
            margin: 0 auto;
        }
        .title {
            font-size: 34px;
            margin-top: 18px;
            margin-bottom: 32px;
        }
        .content {
            font-size: 30px;
            margin-bottom: 48px;
        }
    }
    .ft {
        font-size: 32px;
        color: #ff7a45;
        height: 96px;
        line-height: 96px;
        text-align: center;
        border-top: 2px solid #f5f5f5;
    }
}
</style>
